import styled from '@emotion/styled';
import { colors, Text } from '@innovationdepartment/proxima-ui';
import ChatMessageFeedback from './ChatMessage.Feedback';
import { ChatMessageViewProps } from './types';
import ReactMarkdown from 'react-markdown';

const ChatMessageWrapper = styled.div<{ isAgent: boolean }>`
  align-self: ${({ isAgent }) => (isAgent ? 'flex-start' : 'flex-end')};

  opacity: 0;
  @keyframes fadeIn {
    from {
      margin-top: 20px;
      opacity: 0;
    }
    to {
      margin-top: 0;
      opacity: 1;
    }
  }
  animation: fadeIn 0.3s ease-in-out forwards;
  animation-delay: 0.1s;

  /* hover opacity effect on feedback component */
  & .chat-message-feedback {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover .chat-message-feedback {
    opacity: 1;
  }
`;

const chatBubbleAgentProps = `
  background-color: ${colors.green0};
  border-color: ${colors.green10};
`;

const ChatBubble = styled.div<{ isAgent: boolean }>`
  padding: 12px;
  border-radius: 8px;
  background-color: ${colors.neutral0};
  border: 1px solid ${colors.neutral10};
  max-width: 640px;

  & span {
    font-weight: 500;
  }

  .markdown-body p:first-of-type {
    margin-top: 0;
  }

  .markdown-body p:last-of-type {
    margin-bottom: 0;
  }

  img {
    margin-top: 12px;
  }

  ${({ isAgent }) => {
    if (isAgent) return chatBubbleAgentProps;
    return '';
  }}
`;

const ChatMessageView = (props: ChatMessageViewProps) => {
  const { content, vizBase64, sender } = props;

  const isAgent = sender === 'agent';

  return (
    <ChatMessageWrapper isAgent={isAgent}>
      <ChatBubble isAgent={isAgent}>
        <Text variant="body1Semibold">
          <div className='markdown-body'>
            <ReactMarkdown>
              {content}
            </ReactMarkdown>
          </div>
          {vizBase64 && <img src={`data:image/png;base64,${vizBase64}`} alt="Visualization" />}
        </Text>
      </ChatBubble>
      {isAgent && <ChatMessageFeedback {...props} />}
    </ChatMessageWrapper>
  );
};

export default ChatMessageView;
